import Clipboard from 'clipboard';
import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor($scope) {
       // this.Alert = Alert;
        this.$scope = $scope;
    }
    
    
     $onInit() {
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(()=>{
                this.$scope.spAlert=new  SpAlert('success', 'global.data_copied')
            })
        })
    }
    
}


// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/show-note/show-note.controller.js